import firebase from "firebase";
import { MaxTakeAwaySeliverySlots, Restaurant } from "../../models/restaurant";

export const serializeRestaurantSnap = (
  restaurantSnap: firebase.firestore.DocumentSnapshot
): Restaurant => {
  const data = restaurantSnap.data() ?? {};
  return serializeRestaurant(restaurantSnap.id, data);
};

export const serializeRestaurant = (
  id: string,
  data: {[key:string]: any}
): Restaurant => {
  return {
    id: id,
    logo: data.logo ?? {
      fullPath: '',
      url: '',
    },
    name: data.name ?? '',
    delivery_cost: data.delivery_cost ?? 0,
    coords: data.coords,
    delivery_measure_cost: data.delivery_measure_cost,
    delivery_measure_type: data.delivery_measure_type,
    max_delivery_distance: data.max_delivery_distance,
    min_range_free: data.min_range_free,
    address: data.address,
    free_delivery_minimum_amount: data.free_delivery_minimum_amount,
    minimum_external_order_amount: data.minimum_external_order_amount,
    days_show_slots_takeaway_delivery: data.days_show_slots_takeaway_delivery,
    max_take_away_delivery_slots: serializeMaxTakeAwayDeliverySlots(data.max_take_away_delivery_slots ?? {}),
    take_away_delivery_interval: data.take_away_delivery_interval,
    max_order_approvement_waiting_time: data.max_order_approvement_waiting_time ?? null,
    business_additional_information: data.business_additional_information ?? "",
  };
};

const serializeMaxTakeAwayDeliverySlots = (data: {[key:string]: any}): MaxTakeAwaySeliverySlots|null => {
  if(!data) return null;
  return {
    max_delivery: data.max_delivery ?? 0,
    max_take_away: data.max_take_away ?? 0,
  }
}
